module.exports = __webpack_public_path__ + "static/img/userHead.bc8eb051.png";